import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const SupplierDetailSlice = createSlice({
    name: "supplierDetail",
    initialState,
    reducers: {
        getSupplierDetailRequest(state) {
            state.loading = true;
        },
        getSupplierDetailRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getSupplierDetailRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getSupplierDetailRequest,
    getSupplierDetailRequestSuccess,
    getSupplierDetailRequestError,
} = SupplierDetailSlice.actions;

export default SupplierDetailSlice.reducer;
